import React, {useState} from 'react';
import {login} from '../services/authService';
import './styles/Home.css';
import {useAuth} from "../contexts/AuthContext";
import CustomLoader from "./ux_ui/CustomLoader";
import {Navigate} from "react-router-dom";




const Login = () => {
    const {valid, isCheckingAuth} = useAuth()
    const [isLoggingIn, setIsLoggingIn] = useState(false);


    const handleLogin = async () => {
        try {
            setIsLoggingIn(true);
            window.location.href = await login();
        } catch (err) {

            setIsLoggingIn(false);
        }
    };

    if (isCheckingAuth) {
        return <CustomLoader/>
    }

    if (!valid) {
        return (
            <div className="home-container">
                <div className="background-animation">
                    <div className="floating-shapes">
                        <div className="shape shape-1"></div>
                        <div className="shape shape-2"></div>
                        <div className="shape shape-3"></div>
                        <div className="shape shape-4"></div>
                        <div className="shape shape-5"></div>
                    </div>
                </div>

                <div className="login-card">
                    <div className="login-header">
                        <div className="logo-container">
                            <div className="logo-icon">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h1>CRM System</h1>
                            <p className="subtitle">Secure Authentication Portal</p>
                        </div>
                    </div>

                    <div className="login-content">
                        <div className="welcome-section">
                            <h2>Welcome Back</h2>
                            <p>Sign in to access your dashboard and manage your customer relationships</p>
                        </div>

                        <button
                            onClick={handleLogin}
                            disabled={isLoggingIn}
                            className={`login-button ${isLoggingIn ? 'loading' : ''}`}
                        >
                            {isLoggingIn ? (
                                <>
                                    <div className="button-spinner"></div>
                                    <span>Signing in...</span>
                                </>
                            ) : (
                                <>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
                                            stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                        <polyline points="10,17 15,12 10,7" stroke="currentColor" strokeWidth="2"
                                                  strokeLinecap="round" strokeLinejoin="round"/>
                                        <line x1="15" y1="12" x2="3" y2="12" stroke="currentColor" strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span>Sign In with SSO</span>
                                </>
                            )}
                        </button>

                        <div className="features">
                            <div className="feature">
                                <div className="feature-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                        <path
                                            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor" strokeWidth="2"/>
                                    </svg>
                                </div>
                                <span>Secure Authentication</span>
                            </div>
                            <div className="feature">
                                <div className="feature-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                            stroke="currentColor" strokeWidth="2"/>
                                        <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <span>Real-time Updates</span>
                            </div>
                            <div className="feature">
                                <div className="feature-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 7L10 17L5 12" stroke="currentColor" strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <span>Easy Management</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return <Navigate to={'/dashboard/all-documents'} />
}

export default Login;